var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-card",class:{
    clickable: _vm.clickable,
    depressed: _vm.depressed,
    absolute: _vm.absolute,
    'clickable-shadow': _vm.clickableShadow,
  },on:{"click":function($event){return _vm.$emit("click")}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }